import { Breadcrumbs, visibleCrumbs } from "@vd/ui";
import { open, useLevels } from "../lib/navTrail";

/**
 * The crumbs over a page's title (ADR 0030, DESIGN.md "Navigation and breadcrumbs"), drawn from
 * the navigation trail and the route's crumb declaration. `PageHeader` renders it; a page with
 * its own header places it there. Pages never pass levels. Every level asks first when an
 * editor holds unsaved changes.
 */
export function Crumbs({ className }: { className?: string }) {
  const { above, self } = useLevels();
  // A title inline after the crumbs already names a level (Focus: the list): leave it out.
  const { levels, showSelf, back } = visibleCrumbs(above, self.inlineTitle);
  const up = back === null ? null : above[back];
  return (
    <Breadcrumbs
      above={levels.map((l, i) => ({ label: l.label, onClick: () => open(above, i) }))}
      current={showSelf ? { label: self.label } : null}
      {...(back === null ? {} : { onBack: () => open(above, back), backLabel: up?.label ?? null })}
      {...(className ? { className } : {})}
    />
  );
}
